module.exports = __webpack_public_path__ + "static/media/gallery.42e9cd61.png";